module.exports = __webpack_public_path__ + "static/media/file-medical.4ddfd80d.svg";